const AD_JEWELERY = {
    billboard: {
        desktop: {
            adId: '/5391766/Jewelry_BottomBillboardBanner',
            elementId: 'finding-wide-ad',
            width: 970,
            height: 250,
        },
        tablet: {
            adId: '/5391766/Small_Jewelry_BillboardBanner',
            elementId: 'finding-wide-tablet-ad',
            width: 746,
            height: 192,
        },
        mobile: {
            adId: '/5391766/Jewelry_BillboardBanner_Mobile',
            elementId: 'finding-mobile-ad',
            width: 320,
            height: 82,
        },
    },
    skyscraper: {
        adId: '/5391766/Jewelry_WideSkyscraper',
        elementId: 'finding-narrow-ad',
        width: 160,
        height: 600,
    },
    productTile: [
        {
            adId: '/5391766/FeaturedItem_Jewelry_ONE',
            elementId: 'finding-1x1-ad-1',
            targetEl: 'finding-1x1-ad-wrap-1',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/FeaturedItem_Jewelry_TWO',
            elementId: 'finding-1x1-ad-2',
            targetEl: 'finding-1x1-ad-wrap-2',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/FeaturedItem_Jewelry_THREE',
            elementId: 'finding-1x1-ad-3',
            targetEl: 'finding-1x1-ad-wrap-3',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/FeaturedItem_Jewelry_FOUR',
            elementId: 'finding-1x1-ad-4',
            targetEl: 'finding-1x1-ad-wrap-4',
            width: 331,
            height: 419,
        },
    ],
};

const AD_FASHION = {
    billboard: {
        desktop: {
            adId: '/5391766/Fashion_BillboardBanner',
            elementId: 'finding-wide-ad',
            width: 970,
            height: 250,
        },
        tablet: {
            adId: '/5391766/Small_Fashion_BillboardBanner',
            elementId: 'finding-wide-tablet-ad',
            width: 746,
            height: 192,
        },
        mobile: {
            adId: '/5391766/Fashion_BillboardBanner_Mobile',
            elementId: 'finding-mobile-ad',
            width: 320,
            height: 82,
        },
    },
    skyscraper: {
        adId: '/5391766/Fashion_WideSkyscraper',
        elementId: 'finding-narrow-ad',
        width: 160,
        height: 600,
    },
};

const AD_FURNITURE = {
    billboard: {
        desktop: {
            adId: '/5391766/Bottom_Billboard_Banner',
            elementId: 'finding-wide-ad',
            width: 970,
            height: 250,
        },
        tablet: {
            adId: '/5391766/Small_Furniture_BillboardBanner',
            elementId: 'finding-wide-tablet-ad',
            width: 746,
            height: 192,
        },
        mobile: {
            adId: '/5391766/Bottom_Billboard_Banner_Mobile',
            elementId: 'finding-mobile-ad',
            width: 320,
            height: 82,
        },
    },
    skyscraper: {
        adId: '/5391766/Furniture_WideSkyscraper',
        elementId: 'finding-narrow-ad',
        width: 160,
        height: 600,
    },
    productTile: [
        {
            adId: '/5391766/Featured_Item_v2_ONE',
            elementId: 'finding-1x1-ad-1',
            targetEl: 'finding-1x1-ad-wrap-1',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/Featured_Item_v2_TWO',
            elementId: 'finding-1x1-ad-2',
            targetEl: 'finding-1x1-ad-wrap-2',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/Featured_Item_v2_THREE',
            elementId: 'finding-1x1-ad-3',
            targetEl: 'finding-1x1-ad-wrap-3',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/Featured_Item_v2_FOUR',
            elementId: 'finding-1x1-ad-4',
            targetEl: 'finding-1x1-ad-wrap-4',
            width: 331,
            height: 419,
        },
    ],
};

const AD_ART = {
    billboard: {
        desktop: {
            adId: '/5391766/FineArt_BottomBillboard',
            elementId: 'finding-wide-ad',
            width: 970,
            height: 250,
        },
        tablet: {
            adId: '/5391766/Small_FineArt_BillboardBanner',
            elementId: 'finding-wide-tablet-ad',
            width: 746,
            height: 192,
        },
        mobile: {
            adId: '/5391766/FineArt_BillboardBanner_Mobile',
            elementId: 'finding-mobile-ad',
            width: 320,
            height: 82,
        },
    },
    skyscraper: {
        adId: '/5391766/FineArt_WideSkyscraper',
        elementId: 'finding-narrow-ad',
        width: 160,
        height: 600,
    },
    productTile: [
        {
            adId: '/5391766/FeaturedItem_FineArt_One',
            elementId: 'finding-1x1-ad-1',
            targetEl: 'finding-1x1-ad-wrap-1',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/FeaturedItem_FineArt_Two',
            elementId: 'finding-1x1-ad-2',
            targetEl: 'finding-1x1-ad-wrap-2',
            width: 331,
            height: 419,
        },
    ],
};

const AD_SALE = {
    skyscraper: {
        adId: '/5391766/SaturdaySale_Skyscraper',
        elementId: 'finding-narrow-ad',
        width: 240,
        height: 400,
    },
};

const AD_DEFAULT = {
    billboard: {
        desktop: {
            adId: '/5391766/Bottom_Billboard_Banner',
            elementId: 'finding-wide-ad',
            width: 970,
            height: 250,
        },
    },
};

export const sbAdMap = {
    jewelry: AD_JEWELERY,
    fashion: AD_FASHION,
    furniture: AD_FURNITURE,
    art: AD_ART,
    sale: AD_SALE,
    contemporary: AD_FURNITURE,
    dealers: {}, // No ads for dealer storefronts
    default: AD_DEFAULT,
};
